import React, { useState} from 'react';
import {Button, Box, TextField, Container} from '@mui/material';
import { useTranslation } from "react-i18next";
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import * as Config from '../Config.js'; 


function NewEvent(props) {
    const { t } = useTranslation();
    const [eventName, setEventName] = useState('') ;
    const navigate = useNavigate();

    const addEvent = () => {
        if (eventName.trim() === '') {
            alert("missing event") ;
            return ;
        } 
        
        const data = new FormData();
        data.append('name', eventName);
        
        fetch(Config.apiUrl  + '/site/add-event', {
          method: 'POST',
          credentials: 'include',
          body: data,
        })
        .then(response => response.json())
        .then(res => {
            if (res.success) {
                props.addTrip(false) ;
            } else {
                navigate('/') ;
            }
        })
    }    
   
    
    const cancelEvent = () =>  {
        props.addTrip(false) ;
    }
       
    

    return (
        <Container maxWidth="sm">
            <h2 style={{"text-align": "center"}}>{t("Create Event")}</h2> 
            <Box
                component="form"
                sx={{
                  '& .MuiTextField-root': { m: 1, width: '100%' },
                }}
                noValidate
                autoComplete="off"
            >
                <div>
                    <TextField 
                        required
                        label={t("New Event")} 
                        variant="standard" 
                        onChange={(ev) => setEventName(ev.target.value)} 
                        autoFocus
                    />
                </div>

                <Box
                    display="flex"
                    justifyContent="space-around"
                    alignItems= "center"
                >    
                    <Button variant="outlined" onClick={ () => addEvent()}>{t('Add')}</Button>
                    <Button variant="outlined" onClick={ () => cancelEvent()}>{ t('Cancel')}</Button>
                </Box>
            </Box>    
        </Container>
    );
     
}

export default NewEvent ;